export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-en-AE.aa328cae.xlsx";